import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteChain } from "../api/chains";

export function useDeleteChain() {
  const qc = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: deleteChain,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["chains"] });
    },
  });
}
